module.exports = __webpack_public_path__ + "static/media/hidden-cost.a01c466f.svg";